import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HrDetailsLinkComponent } from './hr-details-link/hr-details-link.component';
import { ManpowerRequisitionFormComponent } from './manpower-requisition-form/manpower-requisition-form.component';
import { MrfUser2Component } from './mrf-user2/mrf-user2.component';
import { MrfDashboardComponent } from './mrf-dashboard/mrf-dashboard.component';
import { MrfHrFormComponent } from './mrf-hr-form/mrf-hr-form.component';
import { MrfPrincipalDeanComponent } from './mrf-principal-dean/mrf-principal-dean.component';
import { BudgetDetailsFormComponent } from './budget-details-form/budget-details-form.component';
import { BudgetReportComponent } from './budget-report/budget-report.component';
import { MrfBudgetReportComponent } from './mrf-budget-report/mrf-budget-report.component';
import { EmployeeWithdrawalComponent } from './employee-withdrawal/employee-withdrawal.component';

const routes: Routes = [
   {
      path: 'hrDetails',
      component: HrDetailsLinkComponent,
      children: [
        { path: '', redirectTo: 'mrfDashboard', pathMatch: 'full' },
        { path: 'manPowerRequisitionForm', component:  ManpowerRequisitionFormComponent},
        { path: 'mrfUser2', component: MrfUser2Component },
        { path: 'mrfDashboard', component: MrfDashboardComponent },
        { path: 'mrfHrForm', component: MrfHrFormComponent },
        { path: 'mrfPrincipalDean', component: MrfPrincipalDeanComponent },
        { path: 'budgetDetails', component: BudgetDetailsFormComponent },
        { path: 'budgetReport', component: BudgetReportComponent },
        { path: 'mrfBudgetReport', component: MrfBudgetReportComponent },
        { path: 'employeeWithdrawal', component: EmployeeWithdrawalComponent },
      ],
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HrRoutingModule { }
